<template>
  <div>
    <transition>
      <div class="head">
        <img class="logoImg" src="../assets/img/logo.png" />
        <div class="point animated" v-bind:class="{ rubberBand: isEffect }">
          所持コイン
          <span>{{ this.$store.state.points }}</span
          >枚
        </div>
      </div>
    </transition>

    <div class="content">
      <div class="container">
        <div class="row">
          <div id="capture" class="eight columns" style="position: relative">
            <img
              id="suisou"
              :style="{ borderColor: suisouBorder }"
              alt
              src="../assets/img/prize/aquarium.png"
            />
            <div class="sakana">
              <img
                @click="sakana(val.id, val.x, val.y)"
                :style="{ left: val.x + '%', top: val.y + '%' }"
                v-for="val in item_image"
                :key="val.id"
                :src="require('../assets/img/prize/' + val.prize + '.png')"
                class="prizeImg"
                v-bind:class="{ prizeBig: val.big }"
              />
            </div>
          </div>

          <div class="four columns">
            <div @click="startGame()" class="button gacha">
              <span>ガチャ</span>
            </div>
            <div @click="confirm('buyModal')" class="button addPoint">
              <span>ショップ</span>
            </div>
            <div @click="ticketModal()" class="button ticket">
              <span>チケット</span>
            </div>
            <div @click="pict()" class="button camera">
              <span>カメラ</span>
            </div>
            <div @click="rirekiModal()" class="button rireki">
              <span>りれき</span>
            </div>
            <div @click="sonotaModal()" class="button sonota">
              <span>その他</span>
            </div>
          </div>
        </div>

        <transition appear name="zoom">
          <div v-if="modalShow" class="modalWindow">
            {{ modalList.Text }}
            <h4
              class="err animated"
              v-if="err"
              v-bind:class="{ rubberBand: isErr }"
            >
              {{ errText }}
            </h4>

            <div v-if="consent" class="row">
              <button
                v-bind:disabled="buttonDisabled"
                @click="isConfirm('c同意')"
                class="button"
              >
                保護者の同意を得ました
              </button>
              <button
                v-bind:disabled="buttonDisabled"
                @click="isConfirm('c成人')"
                class="button"
              >
                成人です
              </button>
              <button
                v-bind:disabled="buttonDisabled"
                @click="isConfirm('cCancel')"
                class="button"
              >
                キャンセル
              </button>
            </div>

            <div v-if="age" class="row">
              <button
                v-bind:disabled="buttonDisabled"
                @click="isConfirm('a16歳未満')"
                class="button"
              >
                16歳未満 1ヶ月5,000円まで
              </button>
              <button
                v-bind:disabled="buttonDisabled"
                @click="isConfirm('a16歳～19歳')"
                class="button"
              >
                16歳～19歳 1ヶ月20,000円まで
              </button>
              <button
                v-bind:disabled="buttonDisabled"
                @click="isConfirm('a20歳以上')"
                class="button"
              >
                20歳以上 制限なし
              </button>
              <button
                v-bind:disabled="buttonDisabled"
                @click="isConfirm('aCancel')"
                class="button"
              >
                キャンセル
              </button>
            </div>

            <div v-if="ticket" class="row">
              <div>
                <label>
                  チケットコード
                  <input v-model="cardNum" type="text" />
                </label>
                <span v-if="prepaidError" class="error">{{ ErrorPre }}</span>
                <button
                  v-bind:disabled="buttonDisabled"
                  @click="buyPrepaid()"
                  class="buyButton"
                >
                  送信
                </button>
              </div>
            </div>

            <div v-if="buy" class="row">
              <div>
                <div
                  v-if="
                    this.$store.state.denwaUse || this.$store.state.creditUse
                  "
                >
                  <input
                    v-model.number="selectDenwa"
                    name="denwaCheck"
                    value="100"
                    id="100"
                    class="denwaCheck"
                    type="radio"
                  />
                  <label for="100" class="buyDenwa">100枚 100円</label>

                  <input
                    v-model.number="selectDenwa"
                    name="denwaCheck"
                    value="500"
                    id="500"
                    class="denwaCheck"
                    type="radio"
                  />
                  <label for="500" class="buyDenwa">500枚 500円</label>

                  <input
                    v-model.number="selectDenwa"
                    name="denwaCheck"
                    value="1000"
                    id="1000"
                    class="denwaCheck"
                    type="radio"
                  />
                  <label for="1000" class="buyDenwa">1000枚 1000円</label>
                </div>
                <label for="denwa" v-if="this.$store.state.denwaUse">
                  電話料金合算払い
                  <input
                    v-model="selectBuy"
                    value="denwa"
                    type="radio"
                    id="denwa"
                  />
                </label>
                <div v-else>電話料金合算払いは停止されています。</div>
                <label v-if="this.$store.state.creditUse" for="credit">
                  クレジットカード払い
                  <input
                    v-model="selectBuy"
                    value="credit"
                    type="radio"
                    id="credit"
                  />
                </label>
                <div v-else>クレジットカード払いは停止されています。</div>
                <div v-if="selectBuy == 'credit'">
                  <label>名前</label>
                  <input type="text" />
                  <label>クレジット番号</label>
                  <input type="text" v-model="creditNum" />
                  <label>有効期限（月/年）例5/20</label>
                  <input class="kigen" type="number" v-model="month" />/
                  <input class="kigen" type="number" v-model="year" />
                  <label>セキュリティコード</label>
                  <input v-model="secCode" type="text" />
                  <div class="err animated" v-if="cardErr">{{ cardErr }}</div>
                </div>
                <button
                  v-if="
                    this.$store.state.denwaUse || this.$store.state.creditUse
                  "
                  v-bind:disabled="buttonDisabled"
                  @click="buyCoin()"
                  class="buyButton"
                >
                  購入
                </button>
              </div>
            </div>

            <div v-if="modalList.rireki" class="u-full-width">
              <h4>コインチケット</h4>
              <div v-for="value in rireki_ticket" :key="value.id">
                {{ value.price }}枚 {{ value.price }}円
              </div>
              <div>合計 {{ this.ticket_total }}円</div>
              <div class="line"></div>

              <h4>電話料金合算払い</h4>
              <div v-for="val in rireki_denwa" :key="val.id">
                {{ val.price }}枚 {{ val.price }}円
              </div>
              <div>合計 {{ this.denwa_total }}円</div>

              <div class="line"></div>
              <h4>クレジットカード</h4>
              <a href="http://www.link-aid.sakura.ne.jp/credit/user"
                >クレジットカード明細</a
              >
            </div>

            <div v-if="sonota" class="u-full-width">
              <Kiyaku></Kiyaku>

              <!-- 個人設定ができるまで一旦削除
              <button @click="sensei()">先生方へ</button>
                <div v-if=hokaMenu.kouka class="switch">
                  <button @click="effectStop()" v-if=this.$store.state.effect class="button-primary">着目機能をOFF</button>
                  <button @click="effectStart()" v-else class="button-primary">着目機能をON</button>
                  <button @click="easyStop()" v-if=this.$store.state.easy class="button-primary">簡単な文字表示をOFF</button>
                  <button @click="easyStart()" v-else class="button-primary">簡単な文字表示をON</button>
                  <button @click="denwaStop()" v-if=this.$store.state.denwaUse class="button-primary">電話料金合算払いの停止</button>
                  <button @click="denwaStart()" v-else class="button-primary">電話料金合算払いの開始</button>
                  <div v-if=denwaInfo>{{ this.denwa_info }}</div>
                </div>
              -->
            </div>

            <div v-if="modal" class="row">
              <button @click="modalCancel()">キャンセル</button>
            </div>
          </div>
        </transition>

        <transition appear name="zoom">
          <div v-if="previewImg" class="previewWindow">
            <div id="previewImage"></div>
            <button @click="previewCancel()">戻る</button>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Kiyaku from "../components/kiyaku.vue";
import axios from "axios";
import html2canvas from "html2canvas";
export default {
  components: {
    Kiyaku,
  },
  name: "home",
  data() {
    return {
      isEffect: false,
      cardNum: "",
      prepaidError: false,
      suisouBorder: "gray",
      consent: false,
      age: false,
      isBuy: "",
      buy: false,
      ticket: false,
      sonota: false,
      modalList: [],
      modalShow: false,
      selectDenwa: "",
      selectCredit: "",
      err: false,
      errText: "",
      isErr: false,
      item_image: [],
      previewImg: false,
      rireki_denwa: [],
      denwa_total: 0,
      rireki_ticket: [],
      ticket_total: "",
      hokaMenu: [{ kouka: false }],
      denwaInfo: false,
      buttonDisabled: false,
      creditNum: "",
      credit: false,
      cardErr: "",
      selectBuy: "",
      secCode: "",
      month: "",
      year: "",
      modal: true,
    };
  },
  created: function () {
    var self = this;
    clearInterval(self.$store.state.routeNext);
    if (!this.$store.state.id) {
      this.$router.push({ name: "selectClass" });
    } else {
      axios
        .get(self.$store.state.APIbase + "api/user/" + self.$store.state.id)
        .then((res) => {
          self.$store.state.classNum = parseInt(res.data.classNum);
          self.$store.state.points = parseInt(res.data.points);
          self.$store.state.gachaTimes = parseInt(res.data.gachaTimes);
          self.$store.state.cardTotal = parseInt(res.data.cardTotal);
          self.$store.state.denwaTotal = parseInt(res.data.denwaTotal);
          self.$store.state.consent = res.data.consent;
          self.$store.state.age = res.data.age;
          self.$store.state.stName = parseInt(res.data.stName);
        });
      axios
        .get(
          self.$store.state.APIbase +
            "api/classroom/" +
            self.$store.state.classNum
        )
        .then((res) => {
          self.$store.state.denwaUse = parseInt(res.data[0].denwaUse);
          self.$store.state.creditUse = parseInt(res.data[0].creditUse);
          self.$store.state.effect = parseInt(res.data[0].effect);
          self.$store.state.easy = parseInt(res.data[0].easy);
          self.$store.state.rateReg = parseInt(res.data[0].rateReg);
          if (self.$store.state.rateReg) {
            self.suisouBorder = "gray";
          } else {
            self.suisouBorder = "#FFD700";
          }
        });
      axios
        .get(self.$store.state.APIbase + "api/prize/" + self.$store.state.id)
        .then((res) => {
          self.item_image = [];
          for (var i = 0; i < res.data.length; i++) {
            var big = false;
            if (
              res.data[i].prize == "jinbei" ||
              res.data[i].prize == "manbou"
            ) {
              big = true;
              var obj = {
                id: i,
                prize: res.data[i].prize,
                x: Math.floor(Math.random() * 40) + 10,
                y: Math.floor(Math.random() * 60) + 10,
                big: big,
              };
            } else {
              obj = {
                id: i,
                prize: res.data[i].prize,
                x: Math.floor(Math.random() * 80) + 5,
                y: Math.floor(Math.random() * 70) + 5,
                big: big,
              };
            }
            self.item_image.push(obj);
          }
        });
    }
  },

  watch: {
    creditNum: function (val) {
      this.creditNum = val.toString().replace(/(\d{4})(?=(\d))/g, "$1 ");
    },
  },

  methods: {
    pict: function () {
      this.previewImg = true;
      html2canvas(document.querySelector("#capture")).then((canvas) => {
        document.getElementById("previewImage").innerHTML = "";
        var child = document.getElementById("previewImage").appendChild(canvas);
        child.style.width = "300px";
        child.style.height = "222px";
        if (canvas.msToBlob) {
          //IE用
          var blob = canvas.msToBlob();
          window.navigator.msSaveBlob(blob, "aqua.png");
        } else {
          //それ以外？
          var dataUrl = canvas.toDataURL("image/png", 0.5);
          var a = document.createElement("a");
          a.href = dataUrl;
          a.download = "aqua.png";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a); //自動クリック
        }
      });
    },
    previewCancel: function () {
      this.previewImg = false;
    },
    sakana: function (id, x) {
      var self = this;
      if (x > 50) {
        self.item_image[id].x = x - 30;
      } else {
        self.item_image[id].x = x + 30;
      }
    },
    startGame: function () {
      var self = this;
      if (self.$store.state.points <= 0) {
        if (self.$store.state.effect == true) {
          self.err = true;
          self.isErr = true;
          self.errText = "コインが足りないよ";
          self.buyModal();
          setTimeout(function () {
            self.isErr = false;
            self.err = false;
          }, 3000);
        } else {
          self.err = true;
          self.errText = "コインが足りないよ";
          self.buyModal();
          setTimeout(function () {
            self.err = false;
          }, 3000);
        }
      } else {
        self.$router.push({ name: "gacha" });
      }
    },
    //年齢確認、保護者の同意
    confirm: function (e) {
      var self = this;
      self.isBuy = e;
      if (self.$store.state.age && self.$store.state.age != "Cancel") {
        //年齢確認済み
        if (e == "buyModal") {
          this.buyModal();
        } else {
          this.ticketModal();
        }
      } else if (
        self.$store.state.consent &&
        self.$store.state.consent != "Cancel"
      ) {
        //同意確認済み
        this.modalList = {
          Text: "あなたの年齢によってコインを買える金額が決まります。必ず正しい年齢を選んでください。",
          rireki: false,
          sonota: false,
        };
        this.modalShow = true;
        this.ticket = false;
        this.buy = false;
        this.sonota = false;
        this.consent = false;
        this.age = true;
        this.modal = false;
      } else {
        //同意確認
        this.modalList = {
          Text: "未成年の方がコインを購入する場合、 保護者の同意が必要です。",
          rireki: false,
          sonota: false,
        };
        this.modalShow = true;
        this.ticket = false;
        this.buy = false;
        this.sonota = false;
        this.consent = true;
        this.age = false;
        this.modal = false;
      }
    },
    isConfirm: function (e) {
      var self = this;
      var kind = e.substr(0, 1);
      var val = e.substr(1);
      var param = {
        kind: kind,
        val: val,
        classNum: this.$store.state.classNum,
        stName: this.$store.state.stName,
      };
      axios
        .put(
          self.$store.state.APIbase +
            "api/user_confirm/" +
            this.$store.state.id,
          param
        )
        .then((res) => {
          if (val == "Cancel") {
            this.modalShow = false;
            this.consent = false;
            this.age = false;
          } else {
            if (kind == "c") {
              self.$store.state.consent = res.data.val;
            } else {
              self.$store.state.age = res.data.val;
            }
            this.confirm(this.isBuy);
          }
        });
    },

    //電話料金合算払い
    buyModal: function () {
      this.modalShow = true;
      this.ticket = false;
      this.buy = true;
      this.sonota = false;
      this.err = false;
      this.modalList = {
        Text: "コインの購入",
        rireki: false,
        sonota: false,
      };
      this.consent = false;
      this.age = false;
      this.modal = true;
    },
    buyCoin: function () {
      var self = this;
      this.buttonDisabled = true;
      var justPoint = self.$store.state.points;
      var newPoint = justPoint + parseInt(self.selectDenwa);
      var price = parseInt(self.selectDenwa);
      var classNum = self.$store.state.classNum;
      var total = self.$store.state.denwaTotal + parseInt(self.selectDenwa);
      if (self.selectBuy == "denwa") {
        if (this.selectDenwa) {
          axios
            .get(
              self.$store.state.APIbase +
                "api/classroom/" +
                self.$store.state.classNum
            )
            .then((res) => {
              self.$store.state.denwaUse = res.data[0].denwaUse;
              if (self.$store.state.denwaUse) {
                var param = {
                  points: newPoint,
                  price: price,
                  classNum: classNum,
                  stName: self.$store.state.stName,
                  denwaTotal: total,
                };
                if (self.$store.state.age == "16歳未満" && total > 5000) {
                  axios
                    .post(
                      self.$store.state.APIbase +
                        "api/user/denwa_log/" +
                        self.$store.state.id,
                      param
                    )
                    .then(() => {
                      self.err = true;
                      self.errText =
                        "16歳未満の電話料金合算払い購入金額は、1か月に5,000円までです。";
                      self.buttonDisabled = false;
                    });
                } else if (
                  self.$store.state.age == "16歳～19歳" &&
                  total > 20000
                ) {
                  axios
                    .post(
                      self.$store.state.APIbase +
                        "api/user/denwa_log/" +
                        self.$store.state.id,
                      param
                    )
                    .then(() => {
                      self.err = true;
                      self.errText =
                        "16歳～19歳の電話料金合算払い購入金額は、1か月に20,000円までです。";
                      self.buttonDisabled = false;
                    });
                } else {
                  axios
                    .put(
                      self.$store.state.APIbase +
                        "api/user/buy/" +
                        self.$store.state.id,
                      param
                    )
                    .then((res) => {
                      self.$store.state.points = res.data["points"];
                      self.$store.state.denwaTotal = res.data["denwaTotal"];
                      self.err = false;
                      self.modalCancel();
                      if (self.$store.state.effect == true) {
                        self.isEffect = true;
                        setTimeout(function () {
                          self.isEffect = false;
                        }, 2000);
                      }
                      self.buttonDisabled = false;
                    })
                    .catch(() => {
                      self.buttonDisabled = false;
                    });
                }
              }
            });
        } else {
          if (self.$store.state.effect == true) {
            self.err = true;
            self.isErr = true;
            self.errText = "枚数をえらんでね";
            self.buyModal();
            setTimeout(function () {
              self.isErr = false;
              self.err = false;
              self.buttonDisabled = false;
            }, 3000);
          } else {
            self.err = true;
            self.errText = "枚数をえらんでね";
            self.buyModal();
            setTimeout(function () {
              self.err = false;
              self.buttonDisabled = false;
            }, 3000);
          }
        }
      } else if (self.selectBuy == "credit") {
        if (this.selectDenwa) {
          if (self.creditNum && self.month && self.year && self.secCode) {
            if (self.year < new Date().getFullYear() - 2000) {
              self.cardErr = "有効期限を過ぎています。このカードは使えません。";
              self.buttonDisabled = false;
            } else {
              if (
                self.year == new Date().getFullYear() - 2000 &&
                self.month < new Date().getMonth() + 1
              ) {
                self.cardErr =
                  "有効期限を過ぎています。このカードは使えません。";
                self.buttonDisabled = false;
                return;
              } else {
                if (self.creditNum.length == 19) {
                  var cNum = self.creditNum.slice(-4);
                  if (
                    self.secCode == Math.floor(Math.abs(Math.cos(cNum)) * 1000)
                  ) {
                    self.cardErr = self.secCode;
                    self.buttonDisabled = false;
                    self.creditBuy();
                  } else {
                    self.cardErr = "セキュリティコードが一致しません。";
                    self.buttonDisabled = false;
                    return;
                  }
                } else {
                  self.cardErr = "カード番号が一致しません。";
                  self.buttonDisabled = false;
                  return;
                }
              }
            }
          } else {
            self.cardErr = "カード情報を入力してください。";
            self.buttonDisabled = false;
            return;
          }
        } else {
          if (self.$store.state.effect == true) {
            self.err = true;
            self.isErr = true;
            self.errText = "枚数をえらんでね";
            self.buyModal();
            setTimeout(function () {
              self.isErr = false;
              self.err = false;
              self.buttonDisabled = false;
            }, 3000);
          } else {
            self.err = true;
            self.errText = "枚数をえらんでね";
            self.buyModal();
            setTimeout(function () {
              self.err = false;
              self.buttonDisabled = false;
            }, 3000);
          }
        }
      } else {
        self.err = true;
        self.errText = "支払方法をえらんでね";
        self.buyModal();
        setTimeout(function () {
          self.err = false;
          self.buttonDisabled = false;
        }, 3000);
      }
    },
    creditBuy: function () {
      var self = this;
      var justPoint = self.$store.state.points;
      var newPoint = justPoint + self.selectDenwa;
      var price = self.selectDenwa;
      var classNum = self.$store.state.classNum;
      var card = {
        username: self.creditNum.replace(/\s+/g, ""),
        password: self.secCode,
      };
      axios
        .get(
          self.$store.state.APIbase +
            "api/classroom/" +
            self.$store.state.classNum
        )
        .then((res) => {
          self.$store.state.creditUse = res.data[0].creditUse;
          if (self.$store.state.creditUse) {
            axios
              .post(self.$store.state.creditCardAPI + "login", card, {
                withCredentials: true,
              })
              .then(() => {
                var cardParam = {
                  cardNum: self.creditNum.replace(/\s+/g, ""),
                  contentName:
                    "たくさん集めて！水族館(" +
                    self.$store.state.classNum +
                    "-" +
                    self.$store.state.stName +
                    ")",
                  price: self.selectDenwa,
                };
                axios
                  .post(
                    self.$store.state.creditCardAPI + "records/cards",
                    JSON.stringify(cardParam),
                    {
                      headers: { "Content-type": "application/json" },
                      withCredentials: true,
                    }
                  )
                  .then(() => {
                    var param = {
                      points: newPoint,
                      price: price,
                      classNum: classNum,
                      stName: self.$store.state.stName,
                    };
                    axios
                      .put(
                        self.$store.state.APIbase +
                          "api/user/credit/" +
                          self.$store.state.id,
                        param
                      )
                      .then((res) => {
                        self.$store.state.points = res.data["points"];
                        self.err = false;
                        self.modalCancel();
                        if (self.$store.state.effect == true) {
                          self.isEffect = true;
                          setTimeout(function () {
                            self.isEffect = false;
                          }, 2000);
                        }
                        self.buttonDisabled = false;
                        self.credit = false;
                      })
                      .catch(() => {
                        self.buttonDisabled = false;
                      });
                  })
                  .catch(() => {
                    self.cardErr = "クレジットカードの購入に失敗しました。";
                    self.buttonDisabled = false;
                  });
              })
              .catch(() => {
                self.cardErr = "クレジットカードの認証に失敗しました。";
                self.buttonDisabled = false;
              });
          }
        });
    },
    //コインチケット
    ticketModal: function () {
      this.modalShow = true;
      this.buy = false;
      this.sonota = false;
      this.ticket = true;
      this.err = false;
      this.modalList = {
        Text: "チケットコード入力",
        rireki: false,
      };
      this.consent = false;
      this.age = false;
      this.modal = true;
    },
    buyPrepaid: function () {
      var self = this;
      self.buttonDisabled = true;
      if (self.cardNum == "") {
        self.ErrorPre = "チケットコードを入力してください";
        self.prepaidError = true;
        self.buttonDisabled = false;
      } else if (self.cardNum.length != 6) {
        self.ErrorPre = "チケットコードが正しくありません";
        self.prepaidError = true;
        self.buttonDisabled = false;
      } else if (
        self.cardNum[0] == "a" ||
        self.cardNum[0] == "b" ||
        self.cardNum[0] == "c"
      ) {
        var param = {
          classNum: self.$store.state.classNum,
          cardNum: self.cardNum,
          id: self.$store.state.id,
          points: self.$store.state.points,
          stName: self.$store.state.stName,
          cardTotal: self.$store.state.cardTotal,
        };
        axios
          .post(self.$store.state.APIbase + "api/card", param)
          .then((res) => {
            self.modalShow = false;
            self.prepaidError = false;
            self.cardNum = "";
            self.$store.state.points = res.data;
            self.err = false;
            if (self.$store.state.effect == true) {
              self.isEffect = true;
              setTimeout(function () {
                self.isEffect = false;
              }, 2000);
            }
            self.buttonDisabled = false;
          })
          .catch((err) => {
            self.ErrorPre = err.response.data;
            self.prepaidError = true;
            self.buttonDisabled = false;
          });
      } else {
        self.ErrorPre = "チケットコードが正しくありません";
        self.prepaidError = true;
        self.buttonDisabled = false;
      }
    },

    modalCancel: function () {
      this.buttonDisabled = false;
      this.modalShow = false;
      this.prepaidError = false;
    },

    rirekiModal: function () {
      var self = this;
      this.modalShow = true;
      this.buy = false;
      this.sonota = false;
      this.ticket = false;
      this.modalList = {
        Text: "使用した履歴です",
        rireki: true,
      };
      this.consent = false;
      this.age = false;
      this.modal = true;
      this.err = false;
      axios
        .get(self.$store.state.APIbase + "api/denwa/" + self.$store.state.id)
        .then((res) => {
          self.rireki_denwa = [];
          self.denwa_total = 0;
          for (var i = 0; i < res.data.length; i++) {
            var obj = {
              id: i,
              price: res.data[i].price,
              updated_at: res.data[i].updated_at,
            };
            self.rireki_denwa.push(obj);
            self.denwa_total += res.data[i].price;
          }
        });
      axios
        .get(self.$store.state.APIbase + "api/card/" + self.$store.state.id)
        .then((res) => {
          self.rireki_ticket = [];
          self.ticket_total = 0;
          for (var i = 0; i < res.data.length; i++) {
            var obj = {
              id: i,
              price: res.data[i].price,
              updated_at: res.data[i].updated_at,
            };
            self.rireki_ticket.push(obj);
            self.ticket_total = self.ticket_total + res.data[i].price;
          }
        });
    },

    sonotaModal: function () {
      this.modalShow = true;
      this.buy = false;
      this.sonota = true;
      this.ticket = false;
      this.modalList = {
        Text: "その他",
        rireki: false,
      };
      this.consent = false;
      this.age = false;
      this.modal = true;
    },
    sensei: function () {
      if (this.hokaMenu.kouka) {
        this.hokaMenu = {
          kiyakuEasy: false,
          kiyakuNormal: false,
          copy: false,
          shikinEasy: false,
          shikinNormal: false,
          tokuteiEasy: false,
          tokuteiNormal: false,
          kouka: false,
        };
      } else {
        this.hokaMenu = {
          kiyakuEasy: false,
          kiyakuNormal: false,
          copy: false,
          shikinEasy: false,
          shikinNormal: false,
          tokuteiEasy: false,
          tokuteiNormal: false,
          kouka: true,
        };
      }
    },

    effectStop: function () {
      var self = this;
      axios
        .put(
          self.$store.state.APIbase +
            "api/effectStop/" +
            self.$store.state.classNum
        )
        .then(() => {
          self.$store.state.effect = 0;
          self.denwa_info = "着目機能を停止しました";
          self.denwaInfo = true;
          setTimeout(function () {
            self.denwaInfo = false;
          }, 2000);
        });
    },
    effectStart: function () {
      var self = this;
      axios
        .put(
          self.$store.state.APIbase +
            "api/effectStart/" +
            self.$store.state.classNum
        )
        .then(() => {
          self.$store.state.effect = 1;
          self.denwa_info = "着目機能を開始しました";
          self.denwaInfo = true;
          setTimeout(function () {
            self.denwaInfo = false;
          }, 2000);
        });
    },
    easyStop: function () {
      var self = this;
      axios
        .put(
          self.$store.state.APIbase +
            "api/easyStop/" +
            self.$store.state.classNum
        )
        .then(() => {
          self.$store.state.easy = 0;
          self.denwa_info = "簡単な文字表示を停止しました";
          self.denwaInfo = true;
          setTimeout(function () {
            self.denwaInfo = false;
          }, 2000);
        });
    },
    easyStart: function () {
      var self = this;
      axios
        .put(
          self.$store.state.APIbase +
            "api/easyStart/" +
            self.$store.state.classNum
        )
        .then(() => {
          self.$store.state.easy = 1;
          self.denwa_info = "簡単な文字表示を開始しました";
          self.denwaInfo = true;
          setTimeout(function () {
            self.denwaInfo = false;
          }, 2000);
        });
    },
    denwaStop: function () {
      var self = this;
      axios
        .put(
          self.$store.state.APIbase +
            "api/denwaStop/" +
            self.$store.state.classNum
        )
        .then(() => {
          self.$store.state.denwaUse = 0;
          self.denwa_info = "電話料金合算払いを停止しました";
          self.denwaInfo = true;
          setTimeout(function () {
            self.denwaInfo = false;
          }, 2000);
        });
    },
    denwaStart: function () {
      var self = this;
      axios
        .put(
          self.$store.state.APIbase +
            "api/denwaStart/" +
            self.$store.state.classNum
        )
        .then(() => {
          self.$store.state.denwaUse = 1;
          self.denwa_info = "電話料金合算払いを開始しました";
          self.denwaInfo = true;
          setTimeout(function () {
            self.denwaInfo = false;
          }, 2000);
        });
    },
  },
};
</script>

<style scoped>
.switch__label {
  width: 60px;
  position: relative;
  top: 3px;
  display: inline-block;
}
.switch__content {
  display: block;
  cursor: pointer;
  position: relative;
  border-radius: 30px;
  height: 31px;
  overflow: hidden;
}
.switch__content:before {
  content: "";
  display: block;
  position: absolute;
  width: calc(100% - 3px);
  height: calc(100% - 3px);
  top: 0;
  left: 0;
  border: 1.5px solid #e5e5ea;
  border-radius: 30px;
  background-color: #fff;
}
.switch__content:after {
  content: "";
  display: block;
  position: absolute;
  background-color: transparent;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  border-radius: 30px;
  transition: all 0.5s;
}
.switch__input {
  display: none;
}

.switch__circle {
  display: block;
  top: 2px;
  left: 2px;
  position: absolute;
  -webkit-box-shadow: 0 2px 6px #999;
  box-shadow: 0 2px 6px #999;
  width: 27px;
  height: 27px;
  -webkit-border-radius: 20px;
  border-radius: 20px;
  background-color: #fff;
  transition: all 0.5s;
}
.switch__input:checked ~ .switch__circle {
  left: 30px;
}

.switch__input:checked ~ .switch__content:after {
  background-color: rgb(213, 245, 253);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.error {
  font-size: 1.4rem;
  font-weight: bold;
  background: rgba(0, 0, 0, 0)
    linear-gradient(transparent 70%, rgb(255, 154, 154) 0%) repeat scroll 0 0;
  position: relative;
  top: -20px;
}

.head {
  width: 100%;
  background: #4690cf;
  transition: height 1s;
  box-shadow: 0px -4px 2px rgba(0, 0, 0, 0.5) inset;
  height: 70px;
}
.logoImg {
  width: 90px;
  padding-left: 20px;
  margin: 0;
  margin-bottom: -20px;
}
.point {
  float: right;
  position: relative;
  top: 0px;
  right: 20px;
  color: white;
}
.point span {
  font-size: 5.2rem;
}

.content {
  text-align: center;
  clear: both;
  position: relative;
  top: 20px;
}
.prizeImg {
  width: 15%;
  position: absolute;
  transition: all 2s ease;
}
.prizeBig {
  width: 30%;
}
#suisou {
  width: 95%;
  border: ridge 3px;
}
.sakana img:nth-child(n) {
  animation: sakana3 2s 0.7s ease alternate infinite;
}
.sakana img:nth-child(2n) {
  animation: sakana1 2s 0s ease alternate infinite;
}
.sakana img:nth-child(3n) {
  animation: sakana2 3s 0s ease alternate infinite;
}
.sakana img:nth-child(5n) {
  animation: sakana4 2s 0.5s ease alternate infinite;
}
.circleButton {
  background: rgb(255, 235, 235);
  border: solid 2px rgb(253, 178, 178);
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.5);
  background-image: url("../assets/img/camera.png");
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: 50%;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  left: 30px;
  transition: all 0.4s;
}
.circleButton:hover {
  transform: scale(1.1);
  background-color: rgba(255, 233, 233, 0.7);
}
.circleButton:active {
  transform: scale(1);
}
.button {
  width: 100%;
  transition: all 0.4s;
  padding: 0;
}
.button:hover {
  transform: scale(1.1);
}
.button:active {
  background: rgba(255, 255, 255, 0.7);
  transform: scale(1);
}
.button img {
  height: 100%;
}
.button span {
  background: rgba(255, 255, 255, 0.7);
}
button:disabled {
  transform: scale(1);
  background: gray;
}
.gacha {
  height: 70px;
  background-image: url("../assets/img/gachabody.png");
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: 50%;
  font-size: 2.2rem;
}
.gacha:active {
  background: rgba(255, 255, 255, 0.7);
  background-image: url("../assets/img/gachabody.png");
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: 50%;
}
.err {
  color: rgb(231, 87, 4);
  font-weight: bold;
  position: relative;
  margin: 5px;
  width: 100%;
}

.addPoint {
  height: 50px;
  background-image: url("../assets/img/coin.png");
  background-size: 40%;
  background-repeat: no-repeat;
  background-position: 50%;
  font-size: 1.8rem;
}
.addPoint:active {
  background: rgba(255, 255, 255, 0.7);
  background-image: url("../assets/img/coin.png");
  background-size: 40%;
  background-repeat: no-repeat;
  background-position: 50%;
}
.camera {
  background-image: url("../assets/img/camera.png");
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: 50%;
  font-size: 1.8rem;
}
.ticket {
  height: 50px;
  background-image: url("../assets/img/ticket.png");
  background-size: 80%;
  background-repeat: no-repeat;
  background-position: 50%;
  font-size: 1.8rem;
}
.rireki {
  background-image: url("../assets/img/rireki.png");
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: 50%;
  font-size: 1.8rem;
}
.sonota {
  background-image: url("../assets/img/sonota.png");
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: 50%;
  font-size: 1.8rem;
}

@media (max-width: 700px) {
  .button {
    width: 15%;
    height: 60px;
    margin-left: 1%;
    font-size: 0.7rem;
    padding-top: 30px;
  }
  .gacha {
    font-size: 0.7rem;
    height: 60px;
    background-size: 80%;
  }
  .addPoint {
    font-size: 0.7rem;
    height: 60px;
    background-size: 80%;
  }
}
.previewWindow {
  width: 300px;
  height: 360px;
  margin-top: -200px;
  margin-left: -180px;
  background: white;
  position: fixed;
  top: 50%;
  left: 50%;
  font-size: 1rem;
  padding: 20px;
  border-radius: 5px;
  overflow: auto;
}
.creditModal {
  width: 300px;
  border: #4690cf solid 3px;
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 10%;
  background: #fff;
  padding: 25px;
  z-index: 999;
}
.modalWindow {
  width: 300px;
  height: 360px;
  margin-top: -200px;
  margin-left: -180px;
  background: white;
  position: fixed;
  top: 50%;
  left: 50%;
  font-size: 1.5rem;
  padding: 20px;
  border-radius: 5px;
  overflow: scroll;
}
.modalWindow button {
  position: relative;
  width: 100%;
  top: 10px;
  font-size: 1rem;
  transition: all 0.4s;
  font-size: 1.3rem;
}
.modalWindow button:hover {
  transform: scale(1.1);
}
.modalWindow button:active {
  transform: scale(1);
}
.modalWindow label {
  margin-top: 10px;
}
.modalWindow .buyButton {
  background: #4690cf;
  color: white;
  width: 50%;
  margin-top: -30px;
}
.modalWindow h6 {
  text-align: left;
  font-size: 1.7rem;
}
.modalWindow p {
  text-align: left;
}
.buyDenwa {
  width: 80%;
  border: solid 1px #4690cf;
  border-radius: 3px;
  height: 30px;
  margin-left: 30px;
  font-size: 1.4rem;
  padding-top: 10px;
  transition: 0.4s all;
}
.denwaCheck:checked + label {
  background: #4690cf;
  color: white;
}
.denwaCheck {
  display: none;
}
.zoom-enter-active {
  animation: zoom-in 0.5s ease-out;
}
.zoom-leave-active {
  animation: zoom-out 0.5s ease-out;
}
@keyframes zoom-in {
  0% {
    transform: scale(0.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes zoom-out {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.1);
  }
}

@keyframes sakana1 {
  0% {
    margin-top: -10px;
  }
  100% {
    margin-top: 10px;
  }
}
@keyframes sakana2 {
  0% {
    margin-top: 10px;
  }
  100% {
    margin-top: -10px;
  }
}
@keyframes sakana3 {
  0% {
    margin-top: -15px;
  }
  100% {
    margin-top: 15px;
  }
}
@keyframes sakana4 {
  0% {
    margin-left: 10px;
  }
  100% {
    margin-left: -10px;
  }
}

.line {
  border-bottom: solid 2px #888;
  height: 1.5rem;
  margin-bottom: 1.5rem;
}
.kigen {
  width: 6rem;
}
</style>
